import React from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Box, Button, Text } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
// import { safeValue } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

const SedangJemputSubmit = ({
    stateData,
    fnRefreshIndex,
    fnCloseDrawer,
    fnSuccessSubmit
}) => {

    const mountedRef = React.useRef(true);

    const { URI1 } = useParams();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        successSubmitNota: 'sedangJemputSubmit-10',
        errorSubmitNota: 'sedangJemputSubmit-11',
    })

    const [data, setData] = React.useState({
        submit: {
            modal: false,
            submitLoading: false,
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const handleSubmit = () => {
        setData(d => ({ ...d, submit: { ...d.submit, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('trx_id', URI1);
        formDT.append('current_step', stateData.utilsRef.currentStep);
        formDT.append('is_cancel', stateData.utilsRef.isCancel);

        formDT.append('next_step', utils.penjemputanSteps.sudah_input_data.value);
        formDT.append('alamat_selector', JSON.stringify(utils.alamatSelector));

        axios({
            method: 'post',
            url: BE_API_THREE + '/submit_sedang_menjemput',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submit: { ...d.submit, submitLoading: false, modal: false } }));

            if (response.data.flag_status === 'isset') {
                notifications.show({
                    id: notificationId.current.successSubmitNota,
                    title: utils.notification.success.caption,
                    message: 'Berhasil Submit Data',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })

                fnCloseDrawer();
                fnSuccessSubmit();
            }

            if (response.data.flag_status === 'not-complete-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: response.data.message,
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitNota,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submit: { ...d.submit, submitLoading: false, modal: false } }));

            notifications.show({
                id: notificationId.current.errorSubmitNota,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <Box
                mt='1.5rem'
                mb='2rem'
            >
                <Text
                    color="dimmed"
                    size='sm'
                    mb='sm'
                >
                    Pastikan data penjemputan sudah terisi dengan benar.
                </Text>

                <Button
                    fullWidth
                    color="blue"
                    onClick={() => setData(d => ({
                        ...d,
                        submit: {
                            ...d.submit,
                            modal: true
                        }
                    }))}
                >
                    Submit Data Penjemputan
                </Button>
            </Box>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.submit.modal}
                fnHide={() => setData(d => ({ ...d, submit: { ...d.submit, modal: false } }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.submit.submitLoading}
                fnButtonAction={handleSubmit}
            >
                <Text size='sm' color="dimmed">Submit Data Penjemputan ?</Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default React.memo(SedangJemputSubmit);